import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { handleToggleFailedTrainingModal } from '../../store/mlcreator-slice/mlcreator';
import { useTranslation } from 'react-i18next';
import FailedDynamicDialog from '../common/FailedDynamicDialog';
import { memo } from 'react';

const FailedTrainingDialog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { failedTrainingDialog } = useAppSelector((state: RootState) => state.mlcreator);

    return (
        <FailedDynamicDialog 
            isOpen={failedTrainingDialog?.isOpen} 
            title={t('ERROR_DIALOG_TITLE')} 
            content={failedTrainingDialog?.body?.message} 
            subContent={failedTrainingDialog?.body?.description}
            onClose={function (): void {
                dispatch(handleToggleFailedTrainingModal({ isOpen: false, body: null }));
            }} 
        />
    );
};

export default memo(FailedTrainingDialog);